<!--
 * @Description: 临时工作任务 添加
 * @Author: ZSC
 * @Date: 2023-03-29 10:32:16.680
 * @LastEditors: PF
 * @LastEditTime: 2023-12-26 10:54:36
-->
<template>
<div class="tan-chuang">
    <el-dialog class="w800 h630" :model-value="lsgzAdd" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">添加临时工作</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('lsgzAdd', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="工作任务标题" prop="gzrwbt" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input v-model="ruleForm.gzrwbt" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="部门" prop="bmid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-cascader :options="buMenTree" clearable filterable  v-model="ruleForm.bmid" :props="{ label: 'jgmc', value: 'id', children: 'children',checkStrictly: true }" @change="rcgzChange">
              </el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="负责人" prop="fzrid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select v-model="ruleForm.fzrid" clearable filterable  @change="bmChange">
                <el-option v-for="item in fzrData" :key="item.id" :label="item.xm" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="要求完成时间" prop="yqwcsj">
              <el-date-picker v-model="ruleForm.yqwcsj" type="datetime" format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="待办内容" prop="dbnr" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input type="textarea" v-model="ruleForm.dbnr" clearable resize="none" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('lsgzAdd', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch, unref } from 'vue'
import { submitForm, closeWindow, loadSelect } from '@/api/common.js'
import { getDate } from '@/utils/index.js'
const props = defineProps({ lsgzAdd: { type: Boolean, required: true } })
const emits = defineEmits(['update:lsgzAdd', 'ReturnData'])
const ruleFormRef = ref(null)
const ruleForm = ref({})

// 选择部门获取人员
const rcgzChange = (val) => {
  const id = Array.isArray(val) ? val[val.length - 1] : val
  loadSelect({
    url: '/api/v2/pdp/jiaozhigong/fuzeren',
    parms: { jgid: id },
    data: fzrData,
    order: 'xm',
    sort: 'asc',
    loadSuccess: function (res) {
      ruleForm.value.fzrid = res.data ? res.data[0].fzrid : ''
    }
  })
}
// 选择人员获取部门
const bmChange = (val) => {
  const obj = fzrData.value.find(item => item.id === val)
  
}

const buMenTree = ref() // 树形部门
const fzrData = ref() // 负责人列表
watch(
  () => props.lsgzAdd,
  () => {
    if (props.lsgzAdd) {
      ruleForm.value.yqwcsj = getDate('YYYY', 'MM', 'DD') + ' 18:00'
      loadSelect({ url: '/api/v2/xiaoneijigou/tree', data: buMenTree })
      loadSelect({ url: '/api/v2/pdp/jiaozhigong/fuzeren', data: fzrData })
    }
  },
  { deep: true, immediate: true }
)

// 提交
const submit = async () => {
  ruleForm.value.bmid = Array.isArray(ruleForm.value.bmid)
    ? ruleForm.value.bmid[ruleForm.value.bmid.length - 1]
    : ruleForm.value.bmid
  submitForm({
    url: '/api/v2/bangong/bangonglinshidaibanshixiang',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function (res) {
      closeWindow('lsgzAdd', emits, true)
    }
  })
}
</script>
